/* global grecaptcha */
import React from "react";
import "./style.scss";
import logo from "../../assets/images/logo.png";
import accutrollLogo from "../../assets/images/accutroll_logo.png";
import { Button, InputGroup, Form, Container, Row, Col, Alert } from "react-bootstrap";

const MAILING_LIST_URL = 'https://api.innotechmarine.co/signup';

export const Herosection = () => {
  const [isEmailSubmitted, setEmailSubmitted] = React.useState(false);
  const [submissionError, setSubmissionError] = React.useState(null);

  const handleSubmit = React.useCallback((e) => {
    e.preventDefault();

    setEmailSubmitted(true);
    
    grecaptcha.ready(function() {
      grecaptcha.execute('6LcYvVYoAAAAABNkBM8DhGGKgIoEX3v9Yg_Me5Bz', {action: 'submit'}).then(function(token) {
        const body = [...e.target.querySelectorAll('input')].reduce((o, input) => {
          o[input.name] = input.value;
          return o;
        }, {token});

        window.fetch(MAILING_LIST_URL, {
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
          }
        })
        .then(async (resp) => {
          if (resp.status === 200) {
            setSubmissionError(null);
          } else {
            const json = await resp.json()
            setSubmissionError(`There was an error signing your email up (${resp.status}: ${json.message}).`)
            console.log(resp)
          }
        })
        .catch((e) => {
          setSubmissionError('Cannot subscribe you to the mailing list. Please try again later.');
          console.log(e)
        })
        .finally(() => {
          setEmailSubmitted(true);
        })
      });
    });

    return false;
  }, []);

  const mailingListForm = React.useMemo(() => {
    if (submissionError) {
      return (
        <Alert variant="warning" className="mt-1">
          {submissionError}
        </Alert>
      )  
    }

    if (isEmailSubmitted) {
      return (
        <Alert variant="light" className="mt-1">
          You're all set! We'll give you periodic updates on Innotech Marine products.
        </Alert>
      )
    }

    return (
      <Form onSubmit={handleSubmit}>
        <InputGroup size="lg" style={{margin: '0.5rem 0'}}>
          <Form.Control type="email" name="email_address" placeholder="Email address" inputMode="email" required />
          <Button type="submit" variant="primary" style={{padding: '0.8em 2em', borderRadius: 6, marginLeft: -6}}>
            Subscribe
          </Button>
        </InputGroup>
      </Form>
    );
  }, [handleSubmit, isEmailSubmitted, submissionError]);

  return (
    <div className="hero">
      <div className="herobg">
        <div className="herodata">
          <Container>
            <Row>
              <Col>
                <div className="logo">
                  <img src={logo} alt="Innotech Marine" width={280} />
                </div>
                <div className="title">
                  We're live!
                  <div>
                    <span className="accent">Now available</span>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="accutroll-logo">
                <img src={accutrollLogo} alt="Accutroll" />
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={5}>
                <p className="copy-text accutroll-announcement">
                  Innotech Marine is excited to announce our new product line Accutroll. Accutroll is an intelligent precision trolling speed control system that can automatically maintain any desired trolling speed. Our e-commerce storefront is now open.
                </p>
                <p className="copy-text accutroll-link">
                  <Button as="a" href="https://accutroll.com" target="_blank" rel="noopener noreferrer" variant="primary" className="accutroll-button">
                    Visit accutroll.com
                  </Button>
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={6} className="mt-4">
                <div className="team-announcement">
                  <h3 className="announcement-title">We're growing our team!</h3>
                  <p className="copy-text team-announcement-text">
                    We're accelerating our marine technology innovations and seeking talented engineers to advance our fishing electronics portfolio, including <a href="https://accutroll.com" target="_blank" rel="noopener noreferrer" className="accutroll-link">Accutroll</a> (accutroll.com). Join us to shape the future of precision fishing systems and collaborate on an exciting partnership with a strategic industry leader!
                  </p>
                  <p className="copy-text opportunities-link">
                    <Button as="a" href="/opportunities" variant="outline-primary" className="opportunities-button">
                      View Open Positions
                    </Button>
                  </p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                Join our mailing list to stay updated!
              </Col>
              <Col sm={12} md={8} lg={5}>
                {mailingListForm}
              </Col>
            </Row>
            <Row>
              <Col className="copy-text" xs={12} style={{textAlign: 'center', margin: '8em 0 2em 0'}}>
                Have a question? <a href="#contact-us">Contact us</a>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
};
